import { Component, OnInit } from '@angular/core';
import { NgForm, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Http } from '@angular/http';
import { AuthService } from '../shared/auth.service';
//import { NotificationService } from '../notification/notification.service';
import { BackendService } from '../shared/backend.service';
import CONFIG from '../config';
import { Router } from '@angular/router';
import { NotificationService } from '../notification.service';
//import { NotificationService } from '../notification.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
  updatePassword: FormGroup;
  updatedProfile: any;
  result: any;
  msg: any;
  submitted: boolean = false;
  logintype: any;

  constructor
    (
      public _formBuilder: FormBuilder,
      public _http: Http,
      public _authService: AuthService,
      public _notificationService: NotificationService,
      public backendservice: BackendService,
      public _router: Router
    ) {
    this.setForm();
  }

  ngOnInit() { }

  ChangePassword(updatedProfile) {
   // console.log(updatedProfile, this._authService.LoginType);

    updatedProfile.logintype = this._authService.LoginType;

    //console.log(updatedProfile.logintype, this._authService.TaskNumber);

 
      this.backendservice.putData(updatedProfile, `${CONFIG.changePasswordApiUrlBase}/${this._authService.TaskNumber}`)
          .subscribe(
          response => {
              this.submitted = false;
              this._notificationService.showNotification({ message: response['msg'], type: 'success' });
              this._authService.logout();
          },
          error => {
              //this.serverErrorOrTimeout(error);
          });

  }



  setForm() {
    this.updatePassword = this._formBuilder.group({
      'CurrentPassword': ['', Validators.required],
      'NewPassword': ['', Validators.pattern('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{6,10}$')],
    });
  }


}
